import {useMutation, useQueryClient} from "@tanstack/react-query";
import {editMenu} from "../../../store/Menu/api";

export const useEditMenu = () => {
    const queryClient = useQueryClient();

    return useMutation(['editCurrentMenu'], ({ params, slug }) => editMenu({ params, slug }), {
        onSuccess: () => {
            queryClient.invalidateQueries(['menu-list']);
        },
    });
}
